// extracted by mini-css-extract-plugin
module.exports = {"card__container":"styles_card__container__3V8TF","card__content":"styles_card__content__GVAm1","card__icon":"styles_card__icon__26EeJ","card__text":"styles_card__text__3BFX5"};